/**
 * 防抖
 * @param {*延迟时间} count
 * @param {*回调函数} callback
 * @returns
 */
let timer;
export const debounce = (count=200, callback) => {
  return (() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback();
    }, count);
  })();
};



/**
 * 节流
 */

// 开始时间
let startTime = Date.now();
export const throttle = (e, i=1000) => {
  return (() => {
    let endTime = Date.now();
    // 现在的时间和开始的时间进行比较
    if (endTime - startTime > i) {
      e()
      // 把endTime作为开始的时间重新进行计算
      startTime = endTime;
    }
  })()
}
